import React from 'react';
import { Select, Button, Space } from 'antd';
import { ReloadOutlined, SaveOutlined } from '@ant-design/icons';
import { PerformancePeriod, Department } from '../../../../services/kpiSettingsService';

interface TargetFilterBarProps {
    periods: PerformancePeriod[];
    departments: Department[];
    selectedPeriodId?: number;
    selectedDeptId?: number;
    onPeriodChange: (val: number) => void;
    onDeptChange: (val?: number) => void;
    onRefresh: () => void;
    onSave: () => void;
    saving: boolean;
}

export const TargetFilterBar: React.FC<TargetFilterBarProps> = ({
    periods, departments, selectedPeriodId, selectedDeptId,
    onPeriodChange, onDeptChange, onRefresh, onSave, saving
}) => {
    return (
        <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Space>
                <span>考核周期：</span>
                <Select
                    style={{ width: 180 }}
                    value={selectedPeriodId}
                    onChange={onPeriodChange}
                    placeholder="选择周期"
                >
                    {periods.map(p => (
                        <Select.Option key={p.id} value={p.id}>{p.name}</Select.Option>
                    ))}
                </Select>
                <span>筛选部门：</span>
                <Select
                    style={{ width: 150 }}
                    value={selectedDeptId}
                    onChange={onDeptChange}
                    allowClear
                    placeholder="全部部门"
                >
                    {departments.map(d => (
                        <Select.Option key={d.id} value={d.id}>{d.name}</Select.Option>
                    ))}
                </Select>
            </Space>
            <Space>
                <Button icon={<ReloadOutlined />} onClick={onRefresh}>刷新</Button>
                <Button type="primary" icon={<SaveOutlined />} onClick={onSave} loading={saving}>保存目标</Button>
            </Space>
        </div>
    );
};
